import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import HTMLParser from 'html-react-parser';

import styles from './styles.module.css';

class QuoteLayout extends React.PureComponent {

  constructor(props) {

    super(props);

    const index = props.section.data.length - 1;
    const align = props.section.data[index].align !== undefined ?
      props.section.data[index].align : 'Left';

    this.state = {
      section: props.section,
      align,
      layout: props.section.data[index].layout,
      full: props.section.data[index].full,
    };

  }

  render() {

    const paragraphAlignStyle = `quoteParagraph${this.state.align}`;
    const quoteExceptionStyle = `quoteException${this.props.themeData.typography.default.fontSize}`;
    const quoteAuthorExceptionStyle = `quoteAuthorException${this.props.themeData.typography.default.fontSize}`;

    const texts = [];
    this.state.section.data.forEach((item, index) => {

      if (item.active) {

        let text;
        if (item.type.startsWith('PARAGRAPH')) {

          if (index === 0) {

            text = (
              <span className={styles[quoteExceptionStyle]} style={{color: this.props.themeData.colors[3]}}>
                { HTMLParser(item.data) }
              </span>
            );

          } else if (index === 1) {

            text = (
              <span className={styles[quoteAuthorExceptionStyle]} style={{color: this.props.themeData.colors[3]}}>
                {HTMLParser(item.data)}
              </span>
            );

          }

        }

        if (text) {

          const content = (
            <div
              key={`${this.state.section._id}_layout_${index}`}
              className={styles[paragraphAlignStyle]}
            >
              { text }
            </div>
          );

          texts.push(content);

        }

      }

      return null;

    });

    const columns = this.state.layout === 'left' ? 'col-12 col-sm-10 offset-sm-1' : 'col-12 col-sm-6';
    const rowWrapper = this.state.layout === 'left' ? '' : `quoteRow${this.state.align}`;
    const container = this.state.layout === 'left' || (this.state.layout !== 'left' && !this.state.full) ? 'container' : undefined;

    const quote = this.state.layout === 'left'
      ? (
        <div className={columns}>
          { texts }
        </div>
      )
      : (
        <div className={`${columns} ${styles.quoteWrapper}`} style={this.state.layout === 'newLeft' ? this.props.boxStyle : undefined}>
          <div className={styles.quoteContentWrapper}>
            { texts }
          </div>
        </div>
      );

    return (
      <div className={container}>
        <div
          className={`row${rowWrapper ? ` ${styles[rowWrapper]}` : ''}`}
          style={!container ? { margin: 0 } : undefined}
        >
          { quote }
        </div>
      </div>
    );

  }

}

QuoteLayout.propTypes = {
  themeData: PropTypes.shape({}),
  section: PropTypes.shape({}),
};

export default CSSModules(
  QuoteLayout, styles,
  { allowMultiple: true },
);
